import apiClient from '../apiClient';
import { POST_CITY_GROUP_DETAIL_URL } from '../apiUrl';

const postCityGroupDetailApi = data => {
  return apiClient.post(POST_CITY_GROUP_DETAIL_URL, data);
};

export default postCityGroupDetailApi;
